import styles from "./first-2d-barcode-shipment-modal.module.css";
import Flex from "../Flex/Flex";
import Button from "../forms/Button/Button";
import IconTextLinkGoogle from "../icons/IconTextLinkGoogle";
import Switch from "../forms/Switch/Switch";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../Modal/Modal";
import { getLocalStorageItem, setLocalStorageItem } from "@/utils/localStorageUtils";
import { useState } from "react";

type First2DBarcodeShipmentModalProps = {
  open: boolean;
  onClose: () => void,
  onConfirm: () => void,
};

const First2DBarcodeShipmentModal = ({
  open,
  onClose,
  onConfirm,
}: First2DBarcodeShipmentModalProps) => {
  const [enabled, setEnabled] = useState(getLocalStorageItem("boxem-DS2DBC", false));

  return (
    <Modal
      className={styles.modal}
      open={open}
      onOpenChange={o => { if (!o) onClose(); }}
    >
      <ModalHeader>
        <div className={styles.titleText}>
          Reminder
        </div>
      </ModalHeader>

      <ModalBody>
        <div className={styles.modalContentContainer}>
          <div className={styles.description}>
            Please make sure you have 2D barcodes enabled on your Amazon Seller account. If you don't, you will run into errors creating your shipment.
          </div>
          <div className={styles.subDescription}>
            To enable 2D barcodes on your account, please read this Help Center article.
          </div>
          <a className={styles.linkContainer} href="https://www.boxem.com/help/how-to-enable-2d-barcodes" target="_blank">
            <IconTextLinkGoogle size={32} style={{ color: "var(--static-text-standard)" }} />
            <div className={styles.linkText}>
              How To Enable 2D Barcodes
            </div>
          </a>
        </div>
      </ModalBody>

      <ModalFooter>
        <Flex
          justify="space-between"
          align="center"
          gap={2}
        >
          <Switch
            label="Don&apos;t show again"
            value={enabled}
            onChange={(value) => {
              setEnabled(value);
              setLocalStorageItem("boxem-DS2DBC", value);
            }}
          />
          <Button
            size="large"
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export default First2DBarcodeShipmentModal;